var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaygroundWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 86.53502 65.81727",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.3976,31.047a2.28289,2.28289,0,0,1,3.2879.37463L65.00676,36.76a6.165,6.165,0,0,0,4.791,2.24777h4.88492a6.23187,6.23187,0,0,1,4.22729,1.59214l6.85765,6.18129a2.34566,2.34566,0,0,1,.18789,3.278,2.63164,2.63164,0,0,1-1.78488.84291,2.55585,2.55585,0,0,1-1.597-.56194L78.62812,46.7812l2.25458,6.83691a1.70239,1.70239,0,0,1-1.597,2.24773h-1.4091l.84544,7.30519a2.36526,2.36526,0,0,1-4.697.56195l-.84547-7.49248a.29955.29955,0,0,0-.28182-.281H71.01893a.24872.24872,0,0,0-.28181.281L69.89168,63.733a2.27247,2.27247,0,0,1-2.34854,2.06042h-.28181A2.33224,2.33224,0,0,1,65.19465,63.171l.84547-7.30519H64.631a1.70238,1.70238,0,0,1-1.597-2.24773l3.38186-10.4895a10.52716,10.52716,0,0,1-5.07277-3.46526l-4.32126-5.33841A2.267,2.267,0,0,1,57.3976,31.047Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 71.95834,
    cy: 31.70258,
    rx: 5.73036,
    ry: 5.71302,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,10.068V63.452a2.12263,2.12263,0,0,0,2.16063,2.1541A2.12263,2.12263,0,0,0,4.32126,63.452V60.82963H20.479V63.452a2.16064,2.16064,0,0,0,4.32126,0V33.20109h1.597a2.68013,2.68013,0,0,1,2.34851,1.31119L44.05805,60.82963a9.752,9.752,0,0,0,8.45463,4.87011h5.44854a3.55895,3.55895,0,1,0,0-7.11786H52.51268a2.68013,2.68013,0,0,1-2.34851-1.31119L34.8519,30.95333a9.752,9.752,0,0,0-8.45464-4.87011h-1.597V9.97437a2.00062,2.00062,0,0,0-.84547-1.68581L13.80925.42145a2.26159,2.26159,0,0,0-2.63034,0L.93941,8.28856A2.39364,2.39364,0,0,0,0,10.068ZM18.1305,21.40041A2.32219,2.32219,0,0,1,15.782,23.74182H9.01828a2.32219,2.32219,0,0,1-2.34851-2.34141v-7.0242a2.32218,2.32218,0,0,1,2.34851-2.3414H15.782a2.32218,2.32218,0,0,1,2.34851,2.3414ZM4.32126,51.55767H20.479v4.96378H4.32126Zm0-9.17829H20.479v4.96377H4.32126Zm0-9.272H20.479v4.96377H4.32126Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaygroundWhite);
export default __webpack_public_path__ + "static/media/Playground_White.9719cb2197637c59cf7b9ec36ab11abb.svg";
export { ForwardRef as ReactComponent };